/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2023, Zumper
 */
import { AutocompleteResult } from '@zcode/bizos'
import type { AutocompleteCityResult } from '@zcode/bizos/declarations/bizos/autocomplete.types'
const NEW_YORK = {
  record_id: 206436573,
  record_type: 'city',
  name: 'New York',
  city: 'New York',
  state: 'NY',
  lat: 40.7306,
  lng: -73.9866,
  country: 'USA',
  url: 'new-york-ny',
  box: [-74.2596399, 40.477399, -73.700292, 40.917577],
} as const

const SAN_FRANCISCO = {
  record_id: 396900358,
  record_type: 'city',
  name: 'San Francisco',
  city: 'San Francisco',
  state: 'CA',
  lat: 37.779026,
  lng: -122.419906,
  country: 'USA',
  url: 'san-francisco-ca',
  box: [-122.5446375, 37.670769, -122.3010701, 37.8664883],
} as const

const CHICAGO = {
  record_id: 529314552,
  record_type: 'city',
  name: 'Chicago',
  city: 'Chicago',
  state: 'IL',
  lat: 41.875562,
  lng: -87.624421,
  country: 'USA',
  url: 'chicago-il',
  box: [-87.869226, 41.644286, -87.509753, 42.0348953],
} as const

const VANCOUVER = {
  record_id: 11927836,
  record_type: 'city',
  name: 'Vancouver',
  city: 'Vancouver',
  state: 'BC',
  lat: 49.260872,
  lng: -123.113952,
  country: 'CAN',
  url: 'vancouver-bc',
  box: [-123.2661436, 49.1985349, -123.021455, 49.31669],
} as const

const TORONTO = {
  record_id: 353773593,
  record_type: 'city',
  name: 'Toronto',
  city: 'Toronto',
  state: 'ON',
  lat: 43.653482,
  lng: -79.383935,
  country: 'CAN',
  url: 'toronto-on',
  box: [-79.4920735, 43.6103651, -79.2791702, 43.7367845],
} as const

const MONTREAL = {
  record_id: 496191206,
  record_type: 'city',
  name: 'Montréal',
  city: 'Montréal',
  state: 'QC',
  lat: 45.503182,
  lng: -73.569807,
  country: 'CAN',
  url: 'montreal-qc',
  box: [-73.7637099, 45.4389276, -73.4927716, 45.7023169],
} as const

const mostPopularCities = [NEW_YORK, SAN_FRANCISCO, CHICAGO, VANCOUVER, TORONTO, MONTREAL] as const

export const POPULAR_SEARCHES = mostPopularCities.map(
  (city) => new AutocompleteResult(city) as AutocompleteCityResult
)
